var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.result)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("error")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }